<template>
    <div data-v-548b72e6>
        <div data-v-548b72e6 class="row">
            <div data-v-548b72e6="" class="LeftPart el-col el-col-24">
                <div data-v-548b72e6="" class="el-card is-never-shadow">
                    <div class="el-card__body" style="padding: 16px; text-align: left;">
                        <div data-v-548b72e6="" class="imgrow">
                            <div v-for="vf in vfile" data-v-548b72e6="" class="Picture">
                                <div data-v-548b72e6="" class="el-image imglist">
                                    <el-image :src="vf" :preview-src-list="srcList" class="imglist">
                                    </el-image>
                                </div>
                            </div>
                        </div>
                        <div data-v-548b72e6="" class="G-title" style="margin-bottom: 5px;"></div>
                        <div data-v-548b72e6="" class="InfoField">
                            <div data-v-548b72e6="" class="InfoHead" style="font-weight: bold;font-size: 16px;">
                                {{ v.title }}
                                <div data-v-548b72e6="">
                                    <div data-v-2a80b29e="" class="ant-tag">商家</div>
                                </div>
                            </div>
                            <div data-v-548b72e6="" class="Profiles">
                                <div data-v-548b72e6="" class="Profile"><svg data-v-73b7ef61="" data-v-548b72e6=""
                                        aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                                        <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                                    </svg> <span data-v-548b72e6="" style="color: rgb(255, 51, 153);">{{ v.dz }}</span>
                                </div>
                            </div>
                            <div data-v-548b72e6="" class="Profiles">
                                <div data-v-548b72e6="" class="Profile">
                                    <div data-v-2a80b29e>
                                        <div data-v-2a80b29e class="mb-2" style="white-space: pre-line !important;">
                                            {{ v.process }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="userpuid===1" data-v-2a80b29e="" class="el-card is-never-shadow" style="user-select: auto;">
                    <div class="el-card__body" style="padding: 16px; text-align: left;">
                        <div data-v-2a80b29e="" class="InfoField">
                        <div data-v-2a80b29e="" class="G-title">
                            <span data-v-2a80b29e="">
                            <svg data-v-73b7ef61="" data-v-2a80b29e="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                                <use data-v-73b7ef61="" xlink:href="#icon-call">
                                </use>
                            </svg>联系方式</span>
                        </div>
                        <div data-v-2a80b29e="" style="padding-top: 5px;">
                            <p data-v-2a80b29e="" style="font-size: 16px;">您需要
                            <a data-v-2a80b29e="" href="/login" class="" style="color: rgb(255, 51, 153); font-size: 16px;">登录</a>才可继续查看联系方式</p>
                            <a href="/login"><button data-v-2a80b29e="" type="button" class="el-button el-button--default el-button--medium is-plain is-round">
                            <span>立即登录</span>
                            </button></a>
                        </div>
                        </div>
                    </div>
                </div>
                <div v-if="userpuid===2" data-v-2a80b29e="" class="el-card is-never-shadow" style="user-select: auto;">
                    <div class="el-card__body" style="padding: 16px; text-align: left;">
                        <div data-v-2a80b29e="" class="InfoField">
                        <div data-v-2a80b29e="" class="G-title">
                            <span data-v-2a80b29e="">
                            <svg data-v-73b7ef61="" data-v-2a80b29e="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                                <use data-v-73b7ef61="" xlink:href="#icon-call">
                                </use>
                            </svg>联系方式</span>
                        </div>
                        <div data-v-2a80b29e="">
                            <div data-v-2a80b29e="" style="padding-top: 5px;">
                            <p data-v-2a80b29e="" style="font-size: 16px;">本信息的联系方式仅
                                <span data-v-2a80b29e="" style="color: rgb(255, 51, 153); font-size: 16px;">VIP会员</span>才能查看</p>
                            </div>
                        </div>
                        <div data-v-2a80b29e="" class="Profiles">
                            <div data-v-2a80b29e="" class="Profile">
                            <a data-v-2a80b29e="" href="/upgrade" class="navbar-nav" style="color: rgb(255, 51, 153);">
                                <button data-v-2a80b29e="" type="button" class="el-button el-button--default el-button--small">
                                <span>
                                    <span data-v-2a80b29e="" style="font-size: 14px;">升级VIP</span>
                                </span>
                                </button>
                            </a>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div v-if="userpuid===3" data-v-2a80b29e="" class="el-card is-never-shadow" style="user-select: auto;">
                    <div class="el-card__body" style="padding: 16px; text-align: left;">
                        <div data-v-2a80b29e="" class="InfoField">
                        <div data-v-2a80b29e="" class="G-title">
                            <span data-v-2a80b29e="">
                            <svg data-v-73b7ef61="" data-v-2a80b29e="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                                <use data-v-73b7ef61="" xlink:href="#icon-call">
                                </use>
                            </svg>联系方式</span>
                        </div>
                        <div data-v-2a80b29e="" class="Profiles">
                            <div data-v-2a80b29e="" class="Profile">
                                <span data-v-83eb46e6="" data-v-291d59e3="" class="g">QQ：</span>
                                <span data-v-83eb46e6="" data-v-291d59e3="">{{v.qq}}</span>
                            </div>
                        </div>
                        <div data-v-2a80b29e="" class="Profiles">
                            <div data-v-2a80b29e="" class="Profile">
                                <span data-v-83eb46e6="" data-v-291d59e3="" class="g">微信：</span>
                                <span data-v-83eb46e6="" data-v-291d59e3="">{{v.wechat}}</span>
                            </div>
                        </div>
                        <div data-v-2a80b29e="" class="Profiles">
                            <div data-v-2a80b29e="" class="Profile">
                                <span data-v-83eb46e6="" data-v-291d59e3="" class="g">电话：</span>
                                <span data-v-83eb46e6="" data-v-291d59e3="">{{v.phone}}</span>
                            </div>
                        </div>
                        <div data-v-2a80b29e="" class="Profiles">
                            <div data-v-2a80b29e="" class="Profile">
                                <span data-v-83eb46e6="" data-v-291d59e3="" class="g">地址：</span>
                                <span data-v-83eb46e6="" data-v-291d59e3="">{{v.address}}</span>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-v-6ef9c908="" data-v-548b72e6="" class="RightPart el-col el-col-24">
                <div data-v-2a80b29e="" class="el-card is-hover-shadow" style="margin-top: 8px;">
                    <div class="el-card__body" style="padding: 0px; height: 100%;">
                        <div data-v-2a80b29e="" class="G-title" style="padding: 15px;"><span
                                data-v-2a80b29e="">风险提示</span></div>
                        <div data-v-2a80b29e="" style="margin: 10px; text-align: left; font-size: 14px;">
                            本站为信息分享平台，并不对寻欢经历负责，请注意个人防范。凡是在联系方式上要求提前付费等类似行为的商家都是骗子商家，请特别警惕推荐办卡行为商家以及引导下载APP的商家，请勿上当受骗。碰到有问题的信息，请注意保护自己并举报给我们删除信息，投诉邮箱hocwfsg@hotmail.com
                        </div>
                    </div>
                </div>
                <div data-v-2a80b29e="" class="el-card is-hover-shadow" style="margin-top: 8px;">
                    <div class="el-card__body" style="padding: 0px; height: 100%;">
                        <div data-v-2a80b29e=""
                            style="margin: 10px; text-align: center; font-size: 14px; font-weight: bold;">
                            如果你有兴趣入驻商家，点击下方了解。
                        </div>
                        <div data-v-2a80b29e="" style="margin: 15px;"><a data-v-2a80b29e="" href="/merchantjoin"
                                class="navbar-nav" style="color: rgb(255, 51, 153);"><button data-v-2a80b29e=""
                                    type="button" class="el-button el-button--default el-button--small"><span><span
                                            data-v-2a80b29e="" style="font-size: 14px;">商家入驻</span></span></button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Merchantshow',
    data() {
        return {
            v: [],
            vfile: [],
            srcList: [],
            rdata: [],

            userpuid:'',
        }
    },
    mounted() {

        let ids = this.$route.query.id

        this.$http.post('/api/merchantshow',{id:ids}).then(res=>{

            this.v = res.data

            this.vfile = JSON.parse(res.data.file)

            this.srcList = JSON.parse(res.data.file)

            this.userpuid = res.data.type

        })

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Merchantshow.vue